export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";